export default __webpack_public_path__ + "static/media/wwf_small@2x.b1d8904a.jpg";